module.exports = __webpack_public_path__ + "static/media/aisect.0200ee7d.png";